// Packages
import React, { useRef } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
// eslint-disable-next-line import/no-webpack-loader-syntax
import iconCheckMens from "!!raw-loader!./icon-check-mens-10.svg"
// eslint-disable-next-line import/no-webpack-loader-syntax
import iconCheckWomens from "!!raw-loader!./icon-check-10.svg"

// Components
// eslint-disable-next-line import/first
import ToolTip from "components/Stacker/components/ToolTip/ToolTip"

// Styles
import "./Swatch.scss"
// eslint-disable-next-line import/first
import { getIsMensExperience } from "components/Stacker/components/Common/helpers"
import { InlineSVGIcon } from "components/Stacker/SvgIcon"
import { StackerContext } from "components/DYStackers/StackerContext"

function SwatchMultiple(props) {
  const element = useRef()
  const handleClick = () => {
    const { handleSwatchChange, index, variantCode } = props
    handleSwatchChange(index, variantCode)
    if (element.current) {
      element.current.checked = true
    }
  }

  const {
    color,
    variantCode,
    colorImage,
    baseCode,
    tabIndex,
    isChecked,
    isSelected,
    className,
    style,
    showTooltip = false,
  } = props

  const dataIndex = props["data-index"]
  const inputId = `${color.split(" ").join("-")}-${variantCode}-${baseCode}`
  const swatchCheckImg =
    StackerContext.gender == "men" ? iconCheckMens : iconCheckWomens

  const combinedStyle = { ...(style || {}), cursor: "pointer" }

  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events
    <label
      onClick={handleClick}
      htmlFor={inputId}
      className={classNames(`Swatch`, className, {
        "swatch-tooltip": showTooltip,
      })}
      style={combinedStyle}
      data-index={dataIndex}
      tabIndex={tabIndex}
    >
      <input
        ref={element}
        onChange={handleClick}
        type="checkbox"
        name={baseCode}
        checked={isChecked}
        aria-label={color}
        style={{ left: "26px" }}
      />
      <div
        className="wrapper d-flex justify-content-center"
        style={{ pointerEvents: "none" }}
      >
        <div
          style={{ pointerEvents: "none" }}
          className={classNames(
            "image-wrapper d-flex align-items-center justify-content-center",
            { "checked-swatch": isChecked },
            { "selected-swatch": isSelected }
          )}
        >
          <img
            src={colorImage}
            className="swatch-image"
            alt="Product"
            style={{ pointerEvents: "none" }}
          />
          {isSelected && (
            <InlineSVGIcon
              iconSvgText={swatchCheckImg}
              alt={"check"}
              style={{
                pointerEvents: "none",
                height: 10,
                width: 10,
                marginBottom: 10,
              }}
              className={""}
            />
          )}
        </div>
      </div>
      {showTooltip && <ToolTip tooltipText={color} />}
    </label>
  )
}

SwatchMultiple.propTypes = {
  handleSwatchChange: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
  colorImage: PropTypes.string.isRequired,
  variantCode: PropTypes.string.isRequired,
  baseCode: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool,
  tabIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.object,
  "data-index": PropTypes.number,
  showTooltip: PropTypes.bool,
}

export default SwatchMultiple
